import type { ReactNode } from "react";
import { Leyenda } from "./Figura";

/** Dumbbell: dos valores por fila (a = hoy, punto marino; b = objetivo, anillo gris) con banda opcional (IPS) y conector. */
export function Dumbbell({ filas, dominio, etiquetaA, etiquetaB, formato, conBanda }: {
  filas: { etiqueta: ReactNode; a: number | null; b: number | null; banda?: { min: number; max: number } | null; nota?: ReactNode }[];
  dominio: [number, number]; etiquetaA: string; etiquetaB: string; formato: (v: number) => string; conBanda?: string;
}) {
  const [d0, d1] = dominio;
  const x = (v: number) => `${Math.max(0, Math.min(1, (v - d0) / (d1 - d0 || 1))) * 100}%`;
  const leyenda = [{ etiqueta: etiquetaA, color: "var(--viz-serie)", forma: "punto" as const }, { etiqueta: etiquetaB, color: "var(--viz-objetivo)", forma: "anillo" as const }];
  if (conBanda) leyenda.push({ etiqueta: conBanda, color: "rgba(61,65,82,.18)", forma: "rect" as never });
  return (
    <div>
      <ul className="flex flex-col gap-4">
        {filas.map((f, i) => {
          const hay = f.a !== null && f.b !== null;
          const lo = hay ? Math.min(f.a!, f.b!) : 0, hi = hay ? Math.max(f.a!, f.b!) : 0;
          return (
            <li key={i}>
              <div className="mb-1.5 flex items-baseline justify-between gap-2 text-sm">
                <span className="font-medium">{f.etiqueta}</span>
                <span className="tabular text-xs text-tinta-suave">{f.a === null ? "—" : formato(f.a)} → {f.b === null ? "—" : formato(f.b)}{f.nota && <> · {f.nota}</>}</span>
              </div>
              <div className="relative h-5" tabIndex={0} aria-label={`${typeof f.etiqueta === "string" ? f.etiqueta : ""} ${etiquetaA} ${f.a === null ? "—" : formato(f.a)}, ${etiquetaB} ${f.b === null ? "—" : formato(f.b)}`}>
                <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2" style={{ background: "var(--viz-grid)" }} />
                {f.banda && <div className="absolute top-0 h-full rounded" style={{ left: x(f.banda.min), width: `calc(${x(f.banda.max)} - ${x(f.banda.min)})`, background: "var(--viz-banda)" }} />}
                {hay && <div className="absolute top-1/2 h-0.5 -translate-y-1/2" style={{ left: x(lo), width: `calc(${x(hi)} - ${x(lo)})`, background: "var(--viz-eje)" }} />}
                {f.b !== null && <div className="absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 bg-white" style={{ left: x(f.b), borderColor: "var(--viz-objetivo)" }} />}
                {f.a !== null && <div className="absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full ring-2 ring-white" style={{ left: x(f.a), background: "var(--viz-serie)" }} />}
              </div>
            </li>
          );
        })}
      </ul>
      <div className="mt-1 flex justify-between text-[11px] text-tinta-suave"><span>{formato(d0)}</span><span>{formato(d1)}</span></div>
      <Leyenda className="mt-2" items={leyenda} />
    </div>
  );
}
